/**
 * activity
 */
export default {
    name: 'activity',
    path: '/activity',
    meta: {},
    component: () => import('@/views/activity/Home'),
    redirect: '/activity/index',
    children: [
        {
            name: 'activityIndex',
            path: 'index',
            meta: {},
            component: () => import('@/views/activity/Index'),
        },
    ],
};
